import LogoutContainer from '../module/Authorization/LogoutContainer';

function LogoutPage() {
  return <LogoutContainer />;
}

export default LogoutPage;
